import axios from "axios";
import { del, get, post, put, patch } from "./api_helper";
import * as url from "./url_helper";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

// get Products
export const getProducts = () => get(url.GET_PRODUCTS);

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });

// get Events

// add Events

// update Event


// delete Event
export const deleteEvent = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteEventMega/${project}`);


// get Categories

// get chats

// get groups
export const getGroups = () => get(url.GET_GROUPS);

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS);

// get messages


// post messages
export const getselectedmails = (selectedmails) => post(url.GET_SELECTED_MAILS, selectedmails);

//post setfolderonmails
export const setfolderonmails = (selectedmails, folderId, activeTab) => post(url.SET_FOLDER_SELECTED_MAILS, { selectedmails, folderId, activeTab });

// get orders
export const getOrders = () => get(url.GET_ORDERS);

// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order);

// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order);

// delete order
export const deleteOrder = order =>
  del(url.DELETE_ORDER, { headers: { order } });

// get cart data
export const getCartData = () => get(url.GET_CART_DATA);

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS);

// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer);

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer);

// delete CUSTOMER
export const deleteCustomer = customer =>
  del(url.DELETE_CUSTOMER, { headers: { customer } });

// get shops
export const getShops = () => get(url.GET_SHOPS);

// get wallet
export const getWallet = () => get(url.GET_WALLET);

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS);

// get crypto product
export const getCryptoProduct = () => get(url.GET_CRYPTO_PRODUCTS);

// get invoices
export const getInvoices = () => get(url.GET_INVOICES);

// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } });

// get jobs
export const getJobList = () => get(url.GET_JOB_LIST);

// get Apply Jobs
export const getApplyJob = () => get(url.GET_APPLY_JOB);

// get project
export const getProjects = () => get(url.GET_PROJECTS);

// get project details
export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } });

// get tasks
export const getTasks = () => get(url.GET_TASKS);

export const getEducationSubItemUsers = user => get(`https://beeducationadmin.stechomeyazilim.info:8093/getPaymentUser/select/${user}`);

export const getEducationSubItem = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getQuizTemplateItemType/select/`);
export const addSubEducation = user => post(`https://beeducationadmin.stechomeyazilim.info:8093/addQuizTemplateItemType/send`, user);
export const updateSubEducation = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateQuizTemplateItemType/${user.ID}`, user);
export const deleteSubEducation = user => del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteQuizTemplateItemType/${user}`);

export const addEducation = user => post(`https://beeducationadmin.stechomeyazilim.info:8093/addEducationNefes/send`, user);


export const getCategory = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getQuizTemplateItem/select/`);
export const addProductCategory = user => post(`https://beeducationadmin.stechomeyazilim.info:8093/addQuizTemplateItem/send`, user);
export const deleteProductCategory = user => del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteQuizTemplateItem/${user}`);
export const updateProductCategory = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateQuizTemplateItem/${user.ID}`, user);

export const addBlog = user => post(`https://beeducationadmin.stechomeyazilim.info:8093/addQuestionEfso/send`, user);
export const deleteBlog = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteQuestionEfso/${project}`);
  export const updateBlog = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateQuestionEfso/${user.ID}`, user);
  export const getBlogs = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getQuestionEfso/select/`);
  
  export const addPdr = user => post(`https://beeducationadmin.stechomeyazilim.info:8093/addWords/send`, user);
  export const deletePdr = project =>
    del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteWords/${project}`);
    export const updatePdr = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateWords/${user.ID}`, user);
    export const getPdr = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getWords/select/`);
    
    export const getSongCategory= () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getSongCategoryEfso/select/`);
export const addSongCategory = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addSongCategoryEfso/send`, job);
export const updateSongCategory = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateSongCategoryrEfso/${user.ID}`, user);
export const deleteSongCategory= user => del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteSongCategoryEfso/${user}`);


export const updateSong = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateSongEfso/${user.ID}`, user);
export const deleteSong= user => del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteSongEfso/${user}`);
export const addSong = user => post(`https://beeducationadmin.stechomeyazilim.info:8093/addSongEfso/send`, user);

export const addNewPost= job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addNewPostEfso/send`, job);

export const updateEducation = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateEducationNefes/${user.ID}`, user);

export const getFeedBack = () => get(`https://kuponadmin.stechomeyazilim.info:9595/getFeedBackKupon/select/`);
export const updateFeedBack = user => patch(`https://kuponadmin.stechomeyazilim.info:9595/updateFeedBackKupon/${user.ID}`, user);
export const addFeedBack= job => post(`https://kuponadmin.stechomeyazilim.info:9595/addFeedBackKupon/send`, job);
export const deleteFeedBack= project =>
del(`https://kuponadmin.stechomeyazilim.info:9595/deleteFeedBackKupon/${project}`);

export const getFeedBackCategory = () => get(`https://kuponadmin.stechomeyazilim.info:9595/getFeedBackCategoryKupon/select/`);
export const updateFeedbackCategory = user => patch(`https://kuponadmin.stechomeyazilim.info:9595/updateFeedbackCategory/${user.ID}`, user);
export const addFeedBackCategory= job => post(`https://kuponadmin.stechomeyazilim.info:9595/addFeedBackCategory/send`, job);
export const deleteFeedBackCategory= project =>
del(`https://kuponadmin.stechomeyazilim.info:9595/deleteFeedBackCategory/${project}`);


export const getPurch = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getPurchEfso/select/`);
export const updatePurch = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updatePurchEfso/${user.ID}`, user);
export const addPurch= job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addPurchEfso/send`, job);
export const deletePurch= project =>
del(`https://beeducationadmin.stechomeyazilim.info:8093/deletePurchEfso/${project}`);


export const getQuizTemplate = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getQuizTemplate/select/`);
export const updateQuizTemplate = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateQuizTemplate/${user.ID}`, user);
export const addQuizTemplate= job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addQuizTemplate/send`, job);
export const deleteQuizTemplate= project =>
del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteQuizTemplate/${project}`);



export const getPostCoach = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getPostCoach/select/`);
export const updatePostCoach = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updatePostCoach/${user.ID}`, user);
export const addPostCoach = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addPostCoach/send`, job);
export const deletePostCoach = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deletePostCoach/${project}`);


export const getBook = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getSubCategoryBee/select/`);
export const updateBook = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateSubCategoryBee/${user.ID}`, user);
export const addBook = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addSubCategoryBee/send`, job);
export const deleteBook = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteSubCategoryBee/${project}`);


export const getMotivation = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getMotivationalQuotesEfso/select/`);
export const updateMotivation = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateMotivationalQuotesEfso/${user.ID}`, user);
export const addMotivation = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addMotivationalQuotesEfso/send`, job);
export const deleteMotivation = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteMotivationalQuotesEfso/${project}`);

export const getPost = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getPostEfso/select/`);
export const updatePost = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updatePostEfso/${user.ID}`, user);
export const addPost = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addPostEfso/send`, job);
export const deletePost = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deletePostEfso/${project}`);

export const getAbout = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getAboutEfso/select/`);
export const updateAbout = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateAboutEfso/${user.ID}`, user);

export const updateContact = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateContactPort/${user.ID}`, user);

export const getLimit = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getTeacherEfso/select/`);
export const addLimit = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addTeacherEfso/send`, job);
export const deleteLimit = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteTeacherEfso/${project}`);
export const updateLimit = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateTeacherEfso/${user.ID}`, user);

export const updateProductSubCategory = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateQuestionSubCategoryEfso/${user.ID}`, user);
export const getSubCategory = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getQuestionSubCategoryEfso/select/`);
export const deleteProductSubCategory = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteQuestionSubCategoryEfso/${project}`);
export const addProductSubCategory = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addQuestionSubCategoryEfso/send`, job);


export const getAvailable = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getStrategy/select/`);
export const updateAvailable = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateStrategy/${user.ID}`, user);
export const addAvailable = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addStrategy/send`, job);
export const deleteAvailable = project =>
del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteStrategy/${project}`);



export const getProductSubSubCategory = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getLessonSubjectEfso/select/`);
export const deleteProductSubSubCategory = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteLessonSubjectEfso/${project}`);
export const updateSubSubProductCategory = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateLessonSubjectEfso/${user.ID}`, user);
export const addProductSubSubCategory = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addProductLessonSubjectEfso/send`, job);



export const addBrand = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addOnBoarding/send`, job);
export const getBrand = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getOnBoarding/select/`);
export const updateBrand = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateOnBoarding/${user.ID}`, user);



export const getAdvert = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getAdvertTekneport/select/`);
export const updateAdvert = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateTekneportAdvert/${user.ID}`, user);
export const addAdvert= job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addAdvertTekneport/send`, job);
export const deleteAdvert= project =>
del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteAdvertPortsPort/${project}`);


export const getSalesPoint = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getQuestionTypeBee/select/`);
export const updateSalesPoint = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateQuestionTypeBee/${user.ID}`, user);
export const addSalesPoint= job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addQuestionTypeBee/send`, job);
export const deleteSalesPoint= project =>
del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteQuestionTypeBee/${project}`);

export const getSchool = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getSchoolEfso/select/`);
export const updateSchool = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateSchoolEfso/${user.ID}`, user);
export const addSchool= job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addSchoolEfso/send`, job);
export const deleteSchool= project =>
del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteSchoolEfso/${project}`);


export const getCounter = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getCounterEfso/select/`);
export const updateCounter = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateCounterEfso/${user.ID}`, user);
export const addCounter= job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addCounterEfso/send`, job);
export const deleteCounter= project =>
del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteCounterEfso/${project}`);


export const getSong= () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getSongEfso/select/`);


export const getReservation = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getLessonEfso2/select/`);
export const getReservationUsers = user => get(`https://beeducationadmin.stechomeyazilim.info:8093/getLessonEfso/select/${user}`);

export const updateReservation = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateLessonEfso/${user.ID}`, user);
export const addReservation = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addLessonEfso/send`, job);
export const deleteReservation = project =>
del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteLessonEfso/${project}`);

export const getOffer = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getOfferPort/select/`);
export const updateOffer = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateSliderPort/${user.ID}`, user);
export const addOffer = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addSliderPort/send`, job);
export const deleteOffer = project =>
del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteSSSPort/${project}`);



export const getSSS = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getSSSEfso/select/`);
export const addSSS= job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addSSSEfso/send`, job);
export const deleteSSS = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteSSSEfso/${project}`);
export const updateSSS = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateSSSEfso/${user.ID}`, user);


export const getUsersTeacher = data => get(`https://beeducationadmin.stechomeyazilim.info:8093/getTeacherOfSchollEfso/select/${data}`,);
export const getUsersStudent = data => get(`https://beeducationadmin.stechomeyazilim.info:8093/getTeacherOfUserEfso2/select/${data}`,);


export const getUsersWeb = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getUsersWebEfso/select/`);
export const addNewUserWeb = user => post(`https://beeducationadmin.stechomeyazilim.info:8093/addUsersEfso/send`, user);
export const deleteUserWeb = user => del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteUsersEfso/${user}`);
export const updateUserWeb = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateUsersEfso/${user.ID}`, user);


export const getUsers = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getUsersEfso/select/`);
export const addNewUser = user => post(`https://beeducationadmin.stechomeyazilim.info:8093/addUsersEfso/send`, user);
export const deleteUser = user => del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteUsersEfso/${user}`);
export const updateUser = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateUsersEfso/${user.ID}`, user);

export const deleteBrand = user => del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteOnBoardingItem/${user}`);

export const getProjectsNew = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getEducationNefes/select/`);
export const getEducation = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getEducationNefes/select/`);
export const getWorkShop = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getSUBDOMAINMega/select/`);

export const getCourseSchedulesMega = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getCourseSchedulesMega/select/`);

export const getWorkshopSessionMega = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getWorkshopSessionMega/select/`);

export const getTeacherMega = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getNotificationEfso/select/`);

export const getEventMega = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getEventMega/select/`);

export const getDynamicFormMega = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getUsersComplateQuestionPdrEfso/select/`);



export const getNews = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getNewsMega/select/`);

export const getMegaMega = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getMegaMega/select/`);

export const getMailsLists = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getContactMessageMega/select/`);

// add user

const postFakeLogin = data => get(`https://beeducationadmin.stechomeyazilim.info:8093/getUsersLoginEfso/select/${data.email}/${data.password}`,);

export const getEvents = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getEventMega/select/`);
export const getCategories = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getEventCategoryMega/select/`);
// update user

export const updateSubDomain = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchSUBDOMAINMega/${user.ID}`, user);

export const updateCourseSchedules = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchCourseSchedulesMega/${user.ID}`, user);

export const updateWorkshopSession = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchWorkShopSessionMega/${user.ID}`, user);

export const updateTeacher = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchUserMega/${user.ID}`, user);

export const getSlider = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getAnnEfso/select/`);
export const getSliders = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getGrammer/select/`);
export const updateSlider = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateGrammer/${user.ID}`, user);
export const addSlider = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addGrammer/send`, job);
export const deleteSlider = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteGrammer/${project}`);
  


export const getProducts1 = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getQuestionSubCategorySubEfso/select/`);
export const updateProduct = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateQuestionSubCategorySubEfso/${user.ID}`, user);
export const addProduct = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addQuestionSubCategorySubEfso/send`, job);
export const deleteProduct = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteQuestionSubCategorySubEfso/${project}`);
  



export const updateProject = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchUpdateProject/${user.ID}`, user);

export const updateNews = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchNews/${user.ID}`, user);


export const addUser = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addUsersDemir/send`, job);


export const addProject = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addProject/send`, job);

export const addNews = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addNews/send`, job);

export const addMega = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addMega/send`, job);

export const addCourseMega = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addCourseMega/send`, job);

export const updateSubdomain = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchSUBDOMAINMega/${user.ID}`, user);



export const updateAuth = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchAuthMega/${user.ID}`, user);

export const updateMega = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchMegaMega/${user.ID}`, user);

export const updateGallery = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchGalleryMega/${user.ID}`, user);

export const updateEvent = event => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchEventMega/${event.ID}`, event);

export const addAppSetting = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/postWSMega/send`, job);

export const addWorkshop2 = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/postWorkshopMega/send`, job);



// delete user

export const getContact = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getContactPort/select/`);
export const getAuthority = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getUsersComplateQuestion/select/`);
export const getWorkshop2 = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getWorkshopMega/select/`);

export const updateWorkShop2 = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchWorkshop2Mega/${user.ID}`, user);

export const getGallery = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getGalleryMega/select/`);

export const addNewEvent = event => post(`https://beeducationadmin.stechomeyazilim.info:8093/postEventMega/send/`, event);

export const getChats = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getContactMessageMega/select/`);

export const getMessages = (roomId = "") => get(`https://beeducationadmin.stechomeyazilim.info:8093/getContactMessageDetailMega/select/${roomId}`);

export const addNewSubdomain = event => post(`https://beeducationadmin.stechomeyazilim.info:8093/postSubdomainMega/send/`, event);
export const getReferances = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getReferancesMega/select/`);
// add jobs
export const addNewJobList = job => post(url.ADD_NEW_JOB_LIST, job);
// update jobs
export const updateJobList = job => put(url.UPDATE_JOB_LIST, job);
// delete jobs
export const deleteJobList = job => del(url.DELETE_JOB_LIST, { headers: { job } });
// Delete Apply Jobs
export const deleteApplyJob = data => del(url.DELETE_APPLY_JOB, { headers: { data } });
/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project);

export const addReferances = event => post(`https://beeducationadmin.stechomeyazilim.info:8093/postReferancesMega/send/`, event);

export const updateReferances = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchReferancesMega/${user.ID}`, user);

export const getSubProject = (ID = "") => get(`https://beeducationadmin.stechomeyazilim.info:8093/getProjectSubItem/select/${ID}`);

export const getTeacherWorkshop = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getTeacherWorkshopMega/select/`);

export const addLessonsTime = event => post(`https://beeducationadmin.stechomeyazilim.info:8093/postLessonsTimeMega/send/`, event);

export const updateLessonsTime = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchTeacherWorkshopMega/${user.ID}`, user);

export const getClassAttendance = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getClassAttendanceMega/select/`);

export const getClassesMega = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getClassesMega/select/`);

export const updateDynamicForm = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/patchDynanicFormMega/${user.ID}`, user);

export const addDynamicForm = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/postDynamicFormMega/send`, job);

export const getDynamicFormExtraMega = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getUsersComplateQuestionPdrEfso/select/`);

export const getDynamicFormExtraExtraMega = (ID = "") => get(`https://beeducationadmin.stechomeyazilim.info:8093/getDynamicFormExtraExtraMega/select/${ID}`);


export const addGallerry = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/postGalleryMega/send`, job);

export const addMultipleGalleryForm = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/postGalleryMultipleMega/send`, job);


export const deleteDynamicFormExtraExtra = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteDynamicExtraExtraFormMega/${project}`);

export const deleteDynamicForm = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteDynamicFormMega/${project}`);

export const deleteDynamicFormExtra = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteDynamicFormExtraMega/${project}`);

export const deleteCourseSchedules = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteCourseSchedulesMega/${project}`);

export const deleteGallery = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteGalleryMega/${project}`);

export const deleteReferances = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteReferancesMega/${project}`);

export const deletePopup = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteLevelEfso/${project}`);
export const addPopup = job => post(`https://beeducationadmin.stechomeyazilim.info:8093/addLevelEfso/send`, job);
export const updatePopup = user => patch(`https://beeducationadmin.stechomeyazilim.info:8093/updateLevelEfso/${user.ID}`, user);
export const getPopup = () => get(`https://beeducationadmin.stechomeyazilim.info:8093/getLevelEfso/select/`);


export const deleteNews = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteNewsMega/${project}`);

export const deleteMega = project =>
  del(`https://beeducationadmin.stechomeyazilim.info:8093/deleteMega/${project}`);

export const deleteProject = project =>
  del(url.DELETE_PROJECT, { headers: { project } });

export const getUserProfile = () => get(url.GET_USER_PROFILE);

// get maillist
//update mail
export const updateMail = mail => put(url.UPDATE_MAIL, mail);

// get folderlist
export const selectFolders = () => get(url.SELECT_FOLDER);

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message);

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);

export const walletBalanceData = month =>
  get(`${url.GET_WALLET_DATA}/${month}`, { params: { month } });

export const getStatisticData = duration =>
  get(`${url.GET_STATISTICS_DATA}/${duration}`, { params: { duration } });

export const visitorData = duration =>
  get(`${url.GET_VISITOR_DATA}/${duration}`, { params: { duration } });

export const topSellingData = month =>
  get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } });

export const getEarningChartsData = month =>
  get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } });

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS);

const onLikeComment = (commentId, productId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
    params: { commentId, productId },
  });
};
const onLikeReply = (commentId, productId, replyId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
    params: { commentId, productId, replyId },
  });
};

const onAddReply = (commentId, productId, replyText) => {
  return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
    params: { commentId, productId, replyText },
  });
};

const onAddComment = (productId, commentText) => {
  return post(`${url.ON_ADD_COMMENT}/${productId}`, {
    params: { productId, commentText },
  });
};

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getProductComents,
  onLikeComment,
  onLikeReply,
  onAddReply,
  onAddComment,
};